import { UntitledIcon } from '@faceup/icons'
import { ulXClose } from '@faceup/icons/ulXClose'
import { defineMessages, useIntl } from '@faceup/localization'
import { Button } from '@faceup/ui-base'

const messages = defineMessages('followUp.components.closeIcon', [
  { id: 'close', defaultMessage: 'Close' },
] as const)

type Props = {
  close: () => void
}

const Close = ({ close }: Props) => {
  const { formatMessage } = useIntl()
  return (
    <Button
      type='text'
      size='middle'
      icon={<UntitledIcon icon={ulXClose} className='text-colorIcon' size={28} />}
      label={formatMessage(messages.close)}
      onClick={() => close()}
    />
  )
}

export default Close
